import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import { Label, Table, Button } from 'reactstrap'
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './dash-journey.css'
import CardDashJourney from "../../../components/card-dash-journey/CardDashJourney";
import CardHoliday from "../../../components/card-holiday/CardHoliday";
import GroupAvaliation from "../../../components/group-avaliation/GroupAvaliation";
import DetailGeneralJpurneyGraph from "../../../components/detail-general-jurney-graph/DetailGeneralJourneyGraph";
import AuditAppointments from "../../../components/audit-appointments/AuditAppointments";
import TollTipChildren from "../../../components/tolltip-children/TollTipChildren";

class DashJourney extends React.Component {
    columns = [
        "Matrícula",
        "Nome / Motorista",
        "Total de Horas",
        "Horas Negativas",
        "Horas Positivas",
        "Saldo de Horas",
    ]

    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            groups: [],
            alert: { msg: '', type: '' },
            loading: true,
            loadingDetails: true,
            topCards: [],
            holidayCards: [],
            groupAvaliation: [],
            detalhesJornada: {},
            detailsJourney: [],
            auditAppointmentsData: [],
            table: [],
            filter: {
                startPeriod: "",
                endPeriod: "",
                idDrivers: [],
            }

        }
    }




    componentDidMount() {
        this.getDash()
        // this.getDash(this.state.filter)
    }

    cardHolidays = (holidays) => {
        let card = holidays
        const cDefault = {
            "day": '',
            "description": "Não há feriados nos próximos 6 meses",
            "dateFormat": "",
            "remainingTime": '):'
        }
        if (holidays.length === 0 || holidays.length > 3) {
            return []
        } else if (holidays.length === 1) {
            card.push(cDefault)
            card.push(cDefault)
            return card
        } else if (holidays.length === 2) {
            card.push(cDefault)
            return card
        }
        else if (holidays.length === 3) {
            return holidays
        }
    }

    auditAppointments = (data) => {
        let dt = []
        data.forEach(d => {
            if (d.label === 'Original') {
                dt.push({ label: d.label, value: parseFloat(d.percent).toFixed(2) * 1, color: 'green' })
            } else if (d.label === 'Alterado ou Justificado') {
                dt.push({ label: d.label, value: parseFloat(d.percent).toFixed(2) * 1, color: 'yellow' })
            }
        })
        return dt
    }

    getDash = (data) => {
        this.setState({
            loading: true,
            // table: {}, 
            alert: { msg: '', type: '' }
        });
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/journey/dashboard/${this.props.token}`,
            data
        })
            .then(d => {
                const data = d.data
                console.log(data)
                const topCards = [
                    { label: 'Motoristas / Usuários', value: data.driverSize, icon: 'persona-icon ', legend: { color: '#3c8100', label: `${data.driverActive} Motoristas Ativos Agora`, icon: 'check-circle-icon' } },
                    { label: 'Horas Negativas', value: data.avgNegativeTime, icon: 'calendar-times-icon', legend: { color: '#d21010', label: 'Média de Horas Negativas Geral', } },
                    { label: 'Horas Positivas', value: data.avgPositiveTime, icon: 'check-circle-icon', legend: { color: '#0037ef', label: 'Média de Horas Positivas Geral', } },
                ]
                const holidayCards = this.cardHolidays(data.holidays)
                const groupAvaliation = data.groupClassification
                const table = data.journeyTable
                const auditAppointmentsData = this.auditAppointments(data.journeyAudit)

                const alert = { msg: !table.length ? 'Não foi possivel localizar resultados para o período selecionado.' : '' }

                this.setState({
                    topCards,
                    holidayCards,
                    groupAvaliation,
                    table,
                    auditAppointmentsData,
                    loading: false,
                    alert

                })
                this.getDetailsJourney();
                //console.log(d.data);
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    getDetailsJourney = () => {
        this.setState({ loadingDetails: true, });
        axios.post(`${url}/v1/telemetria/admin/journey/dashboard/graphicDetail/${this.props.token}`, this.state.filter)
            .then(d => {
                // console.log(d.data)
                this.setState({ detailsJourney: d.data.totals, loadingDetails: false })
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loadingDetails: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    exportJourney = body => {
        if (!this.state.filter.startPeriod || !this.state.filter.endPeriod) return
        this.setState({ loading: true });
        console.log(body)
        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/export/byGeneral/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `general_journey_${body.startPeriod}_${body.endPeriod}.xlsx`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                console.log(data)
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    downloadRep = body => {
        if (!this.state.filter.startPeriod || !this.state.filter.endPeriod) return

        this.setState({ loading: true });

        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/rep/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `rep_${body.startPeriod}_${body.endPeriod}.txt`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                // console.log(data.headers)
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    renderToolbar = () => {
        return (
            <ToolBar zero={false}>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.startPeriod} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                    <Label check className='toolbar-label' style={{ marginTop: '15px' }} />
                </div>

                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button'
                    onClick={() => this.getDash(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div className="row row-inside ">
                        <div className="col-12 no-padding">
                            <div className="row row-inside">
                                {/* Container Principal */}
                                <div className="col-12 col-xl-9 no-padding">
                                    {/* Top Cards */}
                                    <div className="row row-inside">
                                        {this.state.topCards.map((d, i) => {
                                            return (
                                                <div className="col-12 col-md-4" key={i} style={{ marginBottom: '10px' }}>
                                                    <CardDashJourney data={d} />
                                                </div>
                                            )
                                        })}
                                    </div>

                                    {/* Cards Feriados */}
                                    <div className="row row-inside">
                                        {this.state.holidayCards.map((d, i) => {
                                            return (
                                                <div className="col-12 col-md-4" key={i} style={{ marginBottom: '10px' }}>
                                                    <CardHoliday data={d} />
                                                </div>
                                            )
                                        })}
                                    </div>

                                    {/* Avaliaçao por grupo | Detalhamento Geral da Jornada */}
                                    <div className="row row-inside">
                                        <div className="col-12 col-md-4" style={{ marginBottom: '10px' }}>
                                            <GroupAvaliation data={this.state.groupAvaliation} />
                                        </div>
                                        <div className="col-12 col-md-8" style={{ marginBottom: '10px' }}>
                                            {this.state.loadingDetails ? (
                                                <div className="detail-general-journey-graph-container" style={{ height: '292px' }}>
                                                    <Loading />
                                                </div>
                                            ) : (
                                                <DetailGeneralJpurneyGraph data={this.state.detailsJourney} />
                                            )}
                                        </div>

                                    </div>

                                    {/* Tabela Motoristas*/}
                                    <div className="row row-inside">
                                        <div className="col-12" style={{ marginBottom: '10px' }}>
                                            <div className="container-table-drivers">
                                                <div style={{ display: 'flex' }}>
                                                    <div className='export-button-container' style={{ margin: '0 -12px' }}>
                                                        <TollTipChildren text='Exportar Para Excel' id='export-to-excel'>
                                                            <Button
                                                                type="button"
                                                                className='export-button _btn-download'
                                                                id='export-to-excel'
                                                                onClick={() => this.exportJourney(this.state.filter)} disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading} />
                                                        </TollTipChildren>
                                                    </div>
                                                    <div className='export-button-container' style={{ margin: 0 }}>
                                                        <TollTipChildren text='Download Arquivo REP' id='download-rep-file'>
                                                            <Button 
                                                            type="button" 
                                                            className='export-button export-button-orange _btn-download' 
                                                            id='download-rep-file' 
                                                            onClick={() => this.downloadRep(this.state.filter)} 
                                                            disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading} />
                                                        </TollTipChildren>
                                                    </div>

                                                </div>
                                                <div className="table-drivers">
                                                    <Table responsive className="table-change-color">
                                                        <thead>
                                                            <tr>
                                                                {this.columns.map((d, i) => {
                                                                    return (
                                                                        <th key={i}>{d}</th>
                                                                    )
                                                                })}
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {this.state.table.map((d, i) => {

                                                                return (
                                                                    <tr key={i} className='tr-table-pendencie tr-table-change-color'>
                                                                        <td className='td-table-journey-control'>{d.workerId}</td>
                                                                        <td className='td-table-journey-control'>{d.driverName}</td>
                                                                        <td className='td-table-journey-control'>{d.totalTime}</td>
                                                                        <td className='td-table-journey-control'>{d.negativeTime}</td>
                                                                        <td className='td-table-journey-control'>{d.positiveTime}</td>
                                                                        <td className='td-table-journey-control'>{d.balanceTime}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Lateral */}
                                <div className="col-12 col-xl-3">
                                    {/* <div style={{ width: '100%', height: '300px', backgroundColor: 'red' }}></div> */}
                                    <AuditAppointments data={this.state.auditAppointmentsData} />

                                </div>

                            </div>


                        </div>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default DashJourney